/*
 *@Description:系统配置
 *@Author: zhengff
 *@Date: 2019-05-11 10:15:52
 */
import {
  Cache
} from "$utils";
import {
  fetchGet
} from "@src/common/lib/axios";
import fetch from "@src/common/lib/axios";
// function callback(data,length,index,ary,commit){
//   console.log('data+555555',data)
//   console.log('length+',length)
//   console.log('index+',index)
//   data.returnObj.list.map((val)=>{
//     ary.push(val);
//   });
//   if (index==length-1) {
//     console.log('ary',ary)
//     commit('SET_SYS', ary)
//   }
// }
const map = {
  state: {
    map_options: Cache.get("MAP_OPTIONS") || [],
    scoket: Cache.get("SCOKET_OPTIONS")
  },
  actions: {
    // 获取系统配置-接口获取
    GetSysOptions({
      commit
    }) {
      // let sys_dataList = [];
      // let path = process.env.VUE_APP_URL;
      // if (path == "dev") {
      //   path = "config";
      // }
      fetch("/cms/sysConfig/getSysConfigsType.json").then((res) => {
        // console.log('res',res);
        res.returnObj.forEach((val, index) => {
          if (val.code == 3 || val.code == 2 || val.code == 1 || val.code == 5) {
            let param = {
              categoryId: val.code,
              cfgCode: "",
              cfgDesc: "",
              pageNum: 1,
              pageSize: 1000
            };
            fetch("/cms/sysConfig/querySysConfigList.json", param).then(
              (data) => {
                // callback(data,res.returnObj.length,index,sys_dataList,commit)
                // data.returnObj.list.map((val) => {
                //   sys_dataList.push(val);
                // });
                if (data.returnObj.list.length != 0) {
                  if (data.returnObj.list[0].categoryId == "3") {
                    // 阈值
                    commit("SET_SYS", data.returnObj.list[0].cfgValue);
                  }
                  if (data.returnObj.list[0].categoryId == "2") {
                    // console.log(data)
                    //文件
                    commit("SET_VOICE", data.returnObj.list);
                  }
                  if (data.returnObj.list[0].categoryId == "1") {
                    // 系统配置
                    data.returnObj.list.forEach((el) => {
                      if (el.cfgCode == "VIDEO_STREAM_PULL_DURATION") {
                        commit("SET_VPD", el.cfgValue);
                      }
                      // 文件下载路径
                      if (el.cfgCode == "FILEDOWNLOADURL") {
                        commit("SET_FILEURL", el.cfgValue);
                      }
                      // H5
                      if (el.cfgCode == "H5_IP_URL") {
                        // console.log(el)
                        commit("SET_H5", el.cfgValue);
                      }
                      // if (el.cfgCode == "APPOINTMENT_VEHICLE_DEVICENAME") {
                      //   // console.log(el)
                      //   commit("SET_VEHICLE", el.cfgValue);
                      // }
                    });
                  }
                  if (data.returnObj.list[0].categoryId == "5") {
                    // 系统配置
                    data.returnObj.list.forEach((el) => {
                      if (el.cfgCode == "APPOINTMENT_TURNSTILE_DEVICENAME") {
                        commit("SET_TURNSTILE", el.cfgValue);
                      }
                      // 文件下载路径
                      if (el.cfgCode == "APPOINTMENT_VEHICLE_DEVICENAME") {
                        commit("SET_VEHICLE", el.cfgValue);
                      }
                      // H5
                      if (el.cfgCode == "APPOINTMENT_PARKINGLOT_DEVICENAME") {
                        // console.log(el)
                        commit("SET_PARKINGLOT", el.cfgValue);
                      }
                      // if (el.cfgCode == "APPOINTMENT_VEHICLE_DEVICENAME") {
                      //   // console.log(el)
                      //   commit("SET_VEHICLE", el.cfgValue);
                      // }
                    });
                  }
                }
              }
            );
          }
        });
      });
    },
    // 获取系统配置-本地静态配置
    GetSysConfig({
      commit
    }) {
      // fetchGet(`/config/systemConfig.json`).then(response => {
      commit("SET_CONFIG", window.systemConfig);
      // })
    },
    // 获取系统配置-OCX配置
    GetOcxOptions({
      commit
    }) {
      fetch("bms/device/getPlatInfoListByAreaId.json").then((response) => {
        commit("SET_OCX", response);
      });
    }
  },
  mutations: {
    /*
     *@name:系统配置
     *@param:{type}
     *@description:
     *@return:
     *@author: zhengff
     *@date: 2019-05-11 10:15:26
     */
    SET_CONFIG: (state, data) => {
      const mapOps = data.map;
      const socketOps = data.Socket;
      const commonOps = data.Common;
      Cache.put("MAP_OPTIONS", mapOps);
      Cache.put("SCOKET_OPTIONS", socketOps);
      Cache.put("COMMON_OPTIONS", commonOps);

      state.map_options = mapOps;
    },
    SET_SYS: (state, data) => {
      Cache.put("SYS_YUZHI", data);
    },
    SET_VOICE: (state, data) => {
      Cache.put("SYS_VOICE", data);
    },
    SET_VEHICLE: (state, data) => {
      Cache.put("SYS_VEHICLE", data);
    },
    SET_TURNSTILE: (state, data) => {
      Cache.put("SYS_TURNSTILE", data);
    },
    SET_PARKINGLOT: (state, data) => {
      Cache.put("SYS_PARKINGLOT", data);
    },
    SET_H5: (state, data) => {
      Cache.put("SYS_H5", data);
    },
    SET_VPD: (state, data) => {
      Cache.put("SYS_VPD", data);
    },
    SET_FILEURL: (state, data) => {
      Cache.put("SYS_FILEURL", data);
    },
    SET_OCX: (state, data) => {
      const dataOps = data.returnObj;
      Cache.put("OCX_OPTIONS", dataOps);
      Cache.put(
        "VCM_INFO",
        dataOps && dataOps.vcmPlatInfo && dataOps.vcmPlatInfo.length ?
        dataOps.vcmPlatInfo[0] : [{
          vcmPlatCode: ""
        }]
      );
    }
  }
};
export default map;